import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import gmslide1 from "../../../assets/imgs/Grant-Management-Banner.jpg";
import laptopImg from "../../../assets/imgs/gm-video.webp";
import uniqueReqCtaOne from "../../../assets/imgs/uniqueR-1.webp";
import uniqueReqCtaTwo from "../../../assets/imgs/uniqueR-2.webp";
import hippaIcon from "../../../assets/imgs/hippaIcon.webp";
import euGdpr from "../../../assets/imgs/euGdpr.webp";
import upTimeimg from "../../../assets/imgs/99_img.webp";
import outlook from "../../../assets/imgs/gm-outlook.webp";
import sharepoint from "../../../assets/imgs/gm-SharePoint.webp";
import voc from "../../../assets/imgs/voc.webp";
import qb from "../../../assets/imgs/qb.webp";
import crm from "../../../assets/imgs/crm.webp";
import teams from "../../../assets/imgs/gm-Teams.webp";
import twitter from "../../../assets/imgs/x.webp";
import linkdine from "../../../assets/imgs/linkdine.webp";
import fb from "../../../assets/imgs/fb.webp";
import gmail from "../../../assets/imgs/gmail.webp";
import blogOne from "../../../assets/imgs/blog-1.webp";
import blogTwo from "../../../assets/imgs/blog-2.webp";
import blogThree from "../../../assets/imgs/blog-3.webp";
import rcCtaLogo from "../../../assets/imgs/rc-cta-logo.png";
import Resources from "../../Home/Resources";

import "./css/GrantsManagement.css";
import { Helmet } from "react-helmet";
const GrantsManagement = () => {
  useEffect(() => {
    const violation = document.getElementById("top-menu");
    window.scrollTo({
      top: violation.offsetTop,
      // behavior: "smooth",
    });
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Helmet>
        <title>Grant Management Solutions & Services – Right Cause</title>
        <meta name="keywords" content="" />
        <meta
          name="description"
          content="The Right Cause Grants Management Solutions is a unique combination of reliability, power, and value. Modernize the way to engage your donors and explore our Grant Management Services to achieve greater impact."
        />
      </Helmet>
      <header>
        <div class="container-fluid">
          <div class="banner-wrap">
            <div class="banner-slider">
              <div class="banner-slide g-banner">
                <div class="container">
                  <div class="sliderContent">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="slideTxt">
                          <div class="darkTxt g-darkTxt">
                            Data-Driven,
                            <br /> Cloud-enabled Grant Management Services
                          </div>
                          <div class="homesliderbtn">
                            {" "}
                            <a
                              href="#getStrated"
                              class="rc-primary-btn rc-large-btn rc-btn"
                              tabindex="0"
                              aria-label="Get a Demo Button"
                            >
                              Get a Demo <i class="icon-arrow"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="g-mask">
                          <img
                            class="svg-normal-mask"
                            alt="Grant Management Services"
                            src={gmslide1}
                            width="1000"
                            height="667"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <section className="acceleratorCrm-Section">
        <div className="container">
          <div className="row align-items-center text-center">
            <div
              className="col-md-12 col-lg-10 offset-lg-1 mt-xs-3"
              data-aos="zoom-in"
            >
              <div className="h3 blueTxt gms-blue-txt-cc">
                Introducing The Right Cause Grant Accelerator CRM{" "}
              </div>
              <h1 className="h1">
                The ideal Grant Management Solution for admins, reviewers, and
                Grantmakers alike.
              </h1>
              <p>
                The Right Cause Grants Accelerator leverages the robust
                capabilities of Microsoft Dynamics 365, offering a secure and
                efficient Grant Management CRM Solution. It combines online
                capabilities with grant-tracking functionality within a unified
                package.{" "}
              </p>
            </div>
            <div className="col-md-4 col-lg-3 text-center" data-aos="fade-up">
              <div className="solutionIcon">
                <div>
                  {" "}
                  <span className="icon-fundIndicators">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                </div>
                <p className="mt-2">Fund Indicators</p>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center" data-aos="fade-up">
              <div className="solutionIcon">
                <div>
                  <span className="icon-reporting"></span>
                </div>
                <p className="mt-2">Analytics & Reporting</p>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center" data-aos="fade-up">
              <div className="solutionIcon">
                <div>
                  <span className="icon-wealth"></span>
                </div>
                <p className="mt-2">Wealth Screening</p>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center" data-aos="fade-up">
              <div className="solutionIcon">
                <div>
                  <span className="icon-constitute"></span>
                </div>
                <p className="mt-2">Constituent Management</p>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center" data-aos="fade-up">
              <div className="solutionIcon">
                <div>
                  <span className="icon-services"></span>
                </div>
                <p className="mt-2">Integration with Third-party services</p>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center" data-aos="fade-up">
              <div className="solutionIcon">
                <div>
                  <span className="icon-taskmgmt"></span>
                </div>
                <p className="mt-2">Task Management</p>
              </div>
            </div>
            <div className="col-md-4 col-lg-3 text-center" data-aos="fade-up">
              <div className="solutionIcon">
                <div>
                  <span className="icon-portal"></span>
                </div>
                <p className="mt-2">Grantmaker Portal</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="valueProposition-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 col-lg-6" data-aos="zoom-out-right">
              <h3 className="h1">Key Value Proposition</h3>
              <p>
                The Right Cause Grant Accelerator signifies a strategic step
                towards providing a comprehensive, secure, and efficient
                platform for nonprofits to thrive in their missions.{" "}
              </p>
            </div>
            <div className="col-md-6 col-lg-6 mt-xs-3">
              <div className="keyList-item">
                <div className="row">
                  <div
                    className="col-md-12 mb-4 d-flex align-items-center"
                    data-aos="fade-left"
                    data-aos-duration="1000"
                  >
                    <div className="keyList_icon">
                      <span className="icon-oprational"></span>
                    </div>
                    <div className="keyList_content">
                      <strong className="h5">Operational Visibility</strong>
                      <p>
                        Granting key stakeholders enhanced visibility into
                        operations.
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-md-12 mb-4 d-flex align-items-center"
                    data-aos="fade-left"
                    data-aos-duration="1100"
                  >
                    <div className="keyList_icon">
                      <span className="icon-streamline"></span>
                    </div>
                    <div className="keyList_content">
                      <strong className="h5">Streamlined Processes </strong>
                      <p>Automation of manual data entry and donor outreach.</p>
                    </div>
                  </div>
                  <div
                    className="col-md-12 mb-4 d-flex align-items-center"
                    data-aos="fade-left"
                    data-aos-duration="1200"
                  >
                    <div className="keyList_icon">
                      <span className="icon-fundraising"></span>
                    </div>
                    <div className="keyList_content">
                      <strong className="h5">Fundraising Excellence</strong>
                      <p>
                        Implementation of fundraising automation and reminders.
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-md-12 mb-4 d-flex align-items-center"
                    data-aos="fade-left"
                    data-aos-duration="1300"
                  >
                    <div className="keyList_icon">
                      <span className="icon-donor"></span>
                    </div>
                    <div className="keyList_content">
                      <strong className="h5">Donor Engagement</strong>
                      <p>
                        Strategies to nurture and reconnect with inactive
                        donors.
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-md-12 mb-4 d-flex align-items-center"
                    data-aos="fade-left"
                    data-aos-duration="1400"
                  >
                    <div className="keyList_icon">
                      <span className="icon-datasecurity"></span>
                    </div>
                    <div className="keyList_content">
                      <strong className="h5">Data Security</strong>
                      <p>
                        Compliance and robust data security ensured on the
                        Microsoft Cloud.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="our_purposeSection g-cta">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 text-center">
              <div className="largeTxt">
                <div>
                  <img
                    alt="Non-Profit CRM - No bank details required"
                    src={rcCtaLogo}
                    width="77"
                    height="112"
                  />
                  No strings attached. No bank details required.
                </div>
                <a
                  href="#getStrated"
                  className="greenBtn"
                  tabindex="0"
                  aria-label="Enroll for 7-day Free Trial"
                >
                  Enroll for 7-day Free Trial
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="videoDiv" className="videoPlay_section vps-gms-cc">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 text-center mb-3">
              <h1 className="h1">
                Achieve visibility, flexibility, efficiency and automation with
                Right Cause Grants Management Services
              </h1>
              <p>
                The Right Cause provides a Grant Management System to empower
                nonprofits with innovative solutions that go beyond traditional
                CRM capabilities. It signifies a strategic step towards
                providing a comprehensive, secure, and efficient platform for
                nonprofits to thrive in their missions. Integrate Right Cause
                seamlessly with valuable applications such as marketing
                automation and accounting software, as well as key social tools,
                enabling real-time data capture.
              </p>
            </div>
            <div className="col-md-6 col-lg-6 mb-5 mb-cc-none">
              <button
                type="button"
                variant="primary"
                onClick={handleShow}
                className="btn videoplay-Btn"
                // data-bs-toggle="modal"
                // data-bs-target="#videoPlayModal"
                aria-label="Play Video Button"
              ></button>
              <img
                alt="about right cause nonprofit software"
                src={laptopImg}
                width="752"
                height="417"
                className="vplaceholder"
              />
            </div>
            <div className="col-md-6 col-lg-6" data-aos="zoom-out-right">
              <strong>
                Solve critical nonprofit grant management processes with Common
                Data Model{" "}
              </strong>
              <ul className="g-list">
                <li>Grants lifecycle management</li>
                <li> Pre and Post-award activity tracking</li>
                <li> Grantmaker Prospecting </li>
                <li>Grants Application Management </li>
                <li> Grants Approval Automation</li>
                <li> Fund tracking &amp; realization</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="strengthenView">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 col-lg-6">
              <h3 className="h1">
                Strengthen stewardship and engage donors with our Grant
                Management Consulting Services
              </h3>
              <p>
                Upgrade your legacy grant management system with a modern,
                <br /> best-in-className cloud CRM built specifically for
                nonprofit organization will bring the flexibility and automation
                while saving you time and resources. Our experts can help do an
                ROI analysis for your key stakeholders and discover how Right
                Cause Grant Management Solution can deliver immediate visibility
                into your financial data.
              </p>
            </div>
            <div className="col-md-12 col-lg-6">
              <div className="acc-container">
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Grant Management
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Nurture relationships with your existing and potential
                        donors, clients, volunteers, and other stakeholders.
                        Members, donors, and other constituents – as well as
                        staff – can access the system from a web browser.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Application Management
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Send automated communications to applicants and maintain
                        a history of changes made to applications for
                        transparency and accountability. Allow applicants to
                        upload necessary documents in secure SharePoint
                        environment.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Donor Prospecting
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Identify existing donors and relationships between
                        current donors and potential prospects. Rank prospects
                        in terms of their likelihood to donate and Set up
                        real-time alerts for significant changes in a prospect's
                        engagement.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Grant Receives
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Define and track key performance indicators related to
                        grant utilization and program outcomes. Implement
                        features to manage stewardship activities, expressing
                        gratitude to grantors.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        Grant Summary
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Integrate with financial systems to track actual
                        expenses against the set reminders for renewal
                        deadlines. Generate reports on Power BI and measure your
                        program impact and funds dispersed.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapsesix"
                        aria-expanded="false"
                        aria-controls="collapsesix"
                      >
                        Grants Reporting &amp; Analytics
                      </button>
                    </h2>
                    <div
                      id="collapsesix"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Gain immediate visibility into your grant-related data
                        with intuitive, real-time analytics on embedded Power BI
                        Dashboard. We can also help you build custom dashboard
                        for different KPIs.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="reliablitydiv" className="rseSection gms-page-rseSection-cc">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12 text-center">
              <h3 className="h1">
                Easy-to-use, Grant Management CRM with no <br />
                coding required at your end
              </h3>
            </div>
            <div className="col-md-12 col-lg-9 mt-4">
              <div className="d-flex w-100 verticalTabs">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="communication-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#communication"
                      type="button"
                      role="tab"
                      aria-controls="communication"
                      aria-selected="true"
                    >
                      <span className="icon-communication-tab"></span>{" "}
                      Collaboration with stakeholders
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="operability-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#operability"
                      type="button"
                      role="tab"
                      aria-controls="operability"
                      aria-selected="false"
                    >
                      <span className="icon-gsm-tab"></span> Comprehensive Grant
                      Status Monitoring
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="scalability-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#scalability"
                      type="button"
                      role="tab"
                      aria-controls="scalability"
                      aria-selected="false"
                    >
                      <span className="icon-pct-tab"></span> Program Cycle
                      Tracking
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="security-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#security"
                      type="button"
                      role="tab"
                      aria-controls="security"
                      aria-selected="false"
                    >
                      <span className="icon-ct-tab"></span>
                      Category Tracking
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="compliance-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#compliance"
                      type="button"
                      role="tab"
                      aria-controls="compliance"
                      aria-selected="false"
                    >
                      <span className="icon-security-tab"></span>
                      Compliance &amp; Security
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="communication"
                    role="tabpanel"
                    aria-labelledby="communication-tab"
                  >
                    <h3 className="h1">Collaboration with stakeholders</h3>
                    <p>
                      The system establishes seamless connections between all
                      components of each grant proposal, maintaining coherence
                      throughout its entire progression.
                    </p>
                    <ul className="g-list">
                      <li>Approval Process Control</li>
                      <li>Grant Application Management</li>
                      <li>Grant Award Tracking</li>
                      <li>Grant Discovery</li>
                      <li>Workflow Management</li>
                    </ul>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="operability"
                    role="tabpanel"
                    aria-labelledby="operability-tab"
                  >
                    <h3 className="h1">
                      Comprehensive Grant Status Monitoring
                    </h3>
                    <p>
                      Users can effortlessly access and review information on
                      the status of grants, providing a clear overview of each
                      proposal's current stage in the process.
                    </p>
                    <ul className="g-list">
                      <li>Audit Trail</li>
                      <li>Activity Dashboard</li>
                      <li>Administrative Reporting</li>
                      <li>Alerts/Notifications</li>
                      <li>Applicant Tracking</li>
                    </ul>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="scalability"
                    role="tabpanel"
                    aria-labelledby="scalability-tab"
                  >
                    <h3 className="h1">Program Cycle Tracking</h3>
                    <p>
                      Our Nonprofit Management Software is built on Microsoft
                      Dynamics 365 which offers extensive additional
                      functionality over the core CRM packages, including events
                      management, publication distribution, powerful case
                      management extensions and a variety of user interface
                      improvements.
                    </p>
                    <ul className="g-list">
                      <li>Budgeting/Forecasting</li>
                      <li>Categorization/Grouping</li>
                      <li>Deadline Management</li>
                      <li>Document Management</li>
                      <li>Due Date Tracking</li>
                    </ul>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="security"
                    role="tabpanel"
                    aria-labelledby="security-tab"
                  >
                    <h3 className="h1">Category Tracking </h3>
                    <p>
                      Users can track grants based on categories, such as
                      geographic or population-based codes, with the added
                      ability to monitor percentage or dollar allocations tied
                      to the budget.
                    </p>
                    <ul className="g-list">
                      <li>Customizable Branding</li>
                      <li>Customizable Fields</li>
                      <li>Customizable Templates</li>
                      <li>Search/Filter</li>
                      <li>Status Tracking</li>
                    </ul>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="compliance"
                    role="tabpanel"
                    aria-labelledby="compliance-tab"
                  >
                    <h3 className="h1">Compliance &amp; Security </h3>
                    <p>
                      Our security, privacy, and risk-management teams ensure
                      data integrity by adhering to nonprofit industry standard
                      practices, conducting ongoing risk assessments, and
                      aggressively testing the security within Microsoft
                      Cloud.{" "}
                    </p>
                    <ul className="g-list">
                      <li> Role-Based Permissions</li>
                      <li>Internal Network Security </li>
                      <li>Data Protection </li>
                      <li>Azure-first model</li>
                      <li>SharePoint Document Management </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </section>

      <section className="shceduleDemo uniqueRequirments">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <div className="row align-items-center">
                <div className="col-md-6 col-lg-6">
                  <img
                    className="gm-cta1"
                    alt="Discuss your unique requirements"
                    src={uniqueReqCtaOne}
                    width="494"
                    height="182"
                  />
                  <img
                    className="gm-cta2"
                    alt="Real-life examples from nonprofits"
                    src={uniqueReqCtaTwo}
                    width="494"
                    height="182"
                  />
                </div>
                <div className="col-md-6 col-lg-6">
                  <h2 className="h1 mt-xs-3">
                    Let’s discuss your unique requirements and we’ll share
                    real-life examples from nonprofits like yours.
                  </h2>
                  <a
                    href="#getStrated"
                    className="rc-primary-btn rc-large-btn rc-btn mt-xl-3"
                    tabindex="0"
                    aria-label="Request Demo Button"
                  >
                    Request Demo <i className="icon-arrow"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="our_purposeSection g-cta">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 text-center">
              <div className="largeTxt">
                <h2 className="h2">Claim your 7-day Free Trial!</h2>
                <div>
                  Experience the true potential of Right Cause Grants
                  Accelerator at no cost.{" "}
                </div>
                <a
                  href="#getStrated"
                  className="greenBtn"
                  tabindex="0"
                  aria-label="Test Run the CRM at your end."
                >
                  Test Run the CRM at your end.
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="non-profitDiv" className="non-profit-customers">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-12 text-center">
              <h2 className="h1">Use Cases</h2>
              <p>
                A Grant management solution designed to evolve with Non-profits
                of every type and size, the Right Cause Grant Management
                System’s flexible and configurable architecture can be adapted
                and customized to suit the varying approvals, and workflow
                requirements.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="infograph_wrapper">
                <div className="infographFirst_div">
                  <div className="iconWrapper hospice">
                    <p className="iconName">Hospice</p>
                    <div className="icon_div">
                      <i className="icon-hospice"></i>
                    </div>
                  </div>
                  <div className="iconWrapper healthcare">
                    <p className="iconName">Healthcare Organizations</p>
                    <div className="icon_div">
                      <i className="icon-healthcare"></i>
                    </div>
                  </div>
                  <div className="iconWrapper welfare">
                    <p className="iconName">
                      Welfare
                      <br /> organizations
                    </p>
                    <div className="icon_div">
                      <span className="icon-welfare"></span>
                    </div>
                  </div>

                  <div className="iconWrapper chambers">
                    <p className="iconName">
                      Wealth <br /> Managers
                      <br /> &amp; Family
                      <br /> Offices
                    </p>
                    <div className="icon_div">
                      <i className="icon-wealthmanagers"></i>
                    </div>
                  </div>
                  <div className="iconWrapper membership">
                    <p className="iconName">Banks</p>
                    <div className="icon_div">
                      <i className="icon-banks"></i>
                    </div>
                  </div>

                  <div className="iconWrapper churches">
                    <p className="iconName">
                      Nonprofits
                      <br /> &amp; Public <br />
                      Charities
                    </p>
                    <div className="icon_div">
                      <i className="icon-faith"></i>
                    </div>
                  </div>
                </div>
                <div className="infographSecond_div">
                  <div className="iconWrapper faith">
                    <p className="iconName">
                      Private &amp; Family
                      <br />
                      Foundations
                    </p>
                    <div className="icon_div">
                      <i className="icon-membership"></i>
                    </div>
                  </div>
                  <div className="iconWrapper education">
                    <p className="iconName">Higher Ed</p>
                    <div className="icon_div">
                      <i className="icon-education"></i>
                    </div>
                  </div>
                  <div className="iconWrapper govt">
                    <p className="iconName">Government</p>
                    <div className="icon_div">
                      <i className="icon-govt"></i>
                    </div>
                  </div>
                  <div className="iconWrapper student">
                    <p className="iconName">
                      Corporate <br />
                      Foundations
                      <br /> &amp; Giving
                    </p>
                    <div className="icon_div">
                      <i className="icon-corporate"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="rightCause secureGmt">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 col-lg-7">
              <h2 className="h1">
                Secure, reliable, accessible Grant management CRM
              </h2>
              <p>
                Right Cause is built on a Microsoft Dynamics 365 with
                world-className cloud infrastructure with privacy and security
                features designed to ensure data safety.
              </p>
            </div>
            <div className="col-md-12 col-lg-5 ps-xl-5">
              <div className="secureGmt_items--icon cstm-mt">
                <img
                  alt="Hipaa Compliant"
                  src={hippaIcon}
                  width="169"
                  height="92"
                />
              </div>
              <div className="secureGmt_items">
                <div className="secureGmt_items--icon">
                  <img alt="EU GDPR" src={euGdpr} width="120" height="120" />
                </div>
                <div className="secureGmt_items--icon">
                  <img
                    alt="99.9% Up Time"
                    src={upTimeimg}
                    width="120"
                    height="120"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="popularPlatforms">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12 text-center mb-3">
              <h2 className="h1">
                Integrate with popular products and platforms
              </h2>
            </div>
            <div className="col-md-4 col-lg-3 mb-2">
              <div className="platformIcons">
                <img alt="Outlook" src={outlook} width="79" height="79" />
                Outlook
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-2">
              <div className="platformIcons">
                <img alt="SharePoint" src={sharepoint} width="79" height="79" />
                SharePoint
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-2">
              <div className="platformIcons">
                <img alt="Voice of Customer" src={voc} width="79" height="79" />
                Voice of Customer
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-2">
              <div className="platformIcons">
                <img alt="Quickbooks" src={qb} width="79" height="79" />
                Quickbooks
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-2">
              <div className="platformIcons">
                <img alt="CRM systems" src={crm} width="79" height="79" />
                CRM systems
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-2">
              <div className="platformIcons">
                <img alt="Teams" src={teams} width="79" height="79" />
                Teams
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-2">
              <div className="platformIcons">
                <img alt="Twitter" src={twitter} width="79" height="79" />
                Twitter
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-2">
              <div className="platformIcons">
                <img alt="LinkedIn" src={linkdine} width="79" height="79" />
                LinkedIn
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-2">
              <div className="platformIcons">
                <img alt="Facebook" src={fb} width="79" height="79" />
                Facebook
              </div>
            </div>
            <div className="col-md-4 col-lg-3 mb-2">
              <div className="platformIcons">
                <img alt="Email" src={gmail} width="79" height="79" />
                Email
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="our_purposeSection g-cta">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 text-center">
              <div className="largeTxt">
                <div>
                  Build more efficient, inclusive grant management strategy
                  today.
                </div>
                <a
                  href="#getStrated"
                  className="greenBtn"
                  tabindex="0"
                  aria-label="Request Demo Button"
                >
                  Schedule a consultation call
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section id="resourcesDiv" className="resourcesSec">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-lg-12 text-center mb-3">
                        <h2 className="h1">
                            Resources
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 col-lg-4">
                        <div className="card">
                            <div className="resourcesCard_img">
                                <img alt="Non-Profit CRM" src={blogOne} width="419" height="231" />
                            </div>
                            <div className="card-body">
                                <p className="card-subtitle mb-2 text-muted">December 14,2022</p>
                                <h5 className="card-title"><a href="https://www.dynamicscrmconsulting.com/nonprofit-crm/" target="_blank" aria-label="Non-Profit CRM">Non-Profit CRM</a></h5>
                                <p className="card-text">Nonprofit organizations, over the years, have realized the importance
                                    of automation in revolutionizing fundraising...</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-lg-4">
                        <div className="card">
                            <div className="resourcesCard_img">
                                <img alt="Non-Profit CRM" src={blogTwo} width="419" height="231" />
                            </div>
                            <div className="card-body">
                                <p className="card-subtitle mb-2 text-muted">Febuary 22,2023</p>
                                <h5 className="card-title"><a href="https://www.dynamicscrmconsulting.com/grant-management-checklist/" target="_blank" aria-label="How to Manage Grants"> How to Manage Grants
                                    </a></h5>
                                <p className="card-text">For nonprofits, grants can be a crucial source of funding that enables
                                    them to implement crucial initiatives. But managing grants can be a tedious..
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-lg-4">
                        <div className="card">
                            <div className="resourcesCard_img">
                                <img alt="Non-Profit CRM" src={blogThree} width="419" height="231" />
                            </div>
                            <div className="card-body">
                                <p className="card-subtitle mb-2 text-muted">November 29, 2022</p>
                                <h5 className="card-title"><a href="https://www.dynamicscrmconsulting.com/dynamics-365-fundraising-and-engagement/" target="_blank" aria-label="Dynamics 365 Fundraising  "> Dynamics 365 Fundraising
                                    </a></h5>
                                <p className="card-text">Many nonprofit organizations look for ways to improve their operational
                                    efficiencies and efficiently manage their profiles to maintain..</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </section> */}
      <section id="resourceGmsCc">
        <Resources />
      </section>

      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className="modal_getStartedForm"
      >
        <Modal.Header closeButton>
          The Right Cause Grant Accelerator
        </Modal.Header>
        {/* <Fcontact /> */}
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/Yby8S1ytbd4?si=TCMYPaoYIlRr6g67"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </Modal>
    </>
  );
};

export default GrantsManagement;
